import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface Usuario {
  id: string;
  nombre: string;
  email: string;
  rolId: string;
  clinicaId?: string;
  fotoUrl?: string;
}

interface AuthState {
  usuario: Usuario | null;
  isAuthenticated: boolean;
  setAuth: (usuario: Usuario) => void;
  updateUsuario: (patch: Partial<Usuario>) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      usuario: null,
      isAuthenticated: false,
      setAuth: (usuario) => set({ usuario, isAuthenticated: true }),
      updateUsuario: (patch) =>
        set((s) => ({ usuario: s.usuario ? { ...s.usuario, ...patch } : s.usuario })),
      logout: () => set({ usuario: null, isAuthenticated: false }),
    }),
    { name: 'anik-auth' },
  ),
);

export const ROL = {
  SUPER_ADMIN:   'rolsadm01x',
  ADMIN_CLINICA: 'roladmcl02',
  MEDICO:        'rolmedc03y',
  ASISTENTE:     'rolasst04z',
  RECEPCIONISTA: 'rolrecp05w',
  MEDICO_ADMIN:  'rolmedadm06',
} as const;
